import { useEffect, useState } from 'react';
import { fetchPublicConfig, type PublicConfig } from './api';

const FALLBACK: PublicConfig = { socialProviders: [], turnstileSiteKey: null };
let cached: Promise<PublicConfig> | null = null;

/** Which sign-in options the API has switched on. Fetched once per page load. */
export function usePublicConfig(): PublicConfig | undefined {
  const [config, setConfig] = useState<PublicConfig>();
  useEffect(() => {
    cached ??= fetchPublicConfig().catch(() => FALLBACK);
    let active = true;
    void cached.then((value) => {
      if (active) setConfig(value);
    });
    return () => {
      active = false;
    };
  }, []);
  return config;
}
